import React from 'react';
import styles from './Leading.module.scss';

const Leading = () => (
    <div className={styles.Leading}/>
);

export default Leading;
